const chromeCast = {
    data() {
        return {
            remotePlayer: null,
            remotePlayerController: null,
            playerState: null,
            playerStateBeforeSwitch: null,
            mediaInfo: null,
            target: null,
            currentMediaSrc: null
        }
    },
    computed: {
        playerHandler() {
            return this.setupPlayerHandler();
        }
    },
    methods: {
        initializeCastPlayer() {
            var options = {};
            // Set the receiver application ID to your own (created in the
            // Google Cast Developer Console), or optionally
            // use the chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID
            options.receiverApplicationId = chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID;

            // Auto join policy can be one of the following three:
            // ORIGIN_SCOPED - Auto connect from same appId and page origin
            // TAB_AND_ORIGIN_SCOPED - Auto connect from same appId, page origin, and tab
            // PAGE_SCOPED - No auto connect
            options.autoJoinPolicy = chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED;

            /** The following flag enables Cast Connect(requires Chrome 87 or higher) */
            options.androidReceiverCompatible = true;

            cast.framework.CastContext.getInstance().setOptions(options);
            this.remotePlayer = new cast.framework.RemotePlayer();
            this.remotePlayerController = new cast.framework.RemotePlayerController(this.remotePlayer);

            /**
             * When cast device is connected/disconnected (connection changed event) then switch player
             * and configure cast and local player
             */
            this.remotePlayerController.addEventListener(
                cast.framework.RemotePlayerEventType.IS_CONNECTED_CHANGED,
                function (e) {
                    this.switchPlayer();
                }.bind(this)
            );
        },

        switchPlayer() {
            this.playerStateBeforeSwitch = this.playerState;
            // Session is active
            if (cast && cast.framework && this.remotePlayer.isConnected) {
                this.setupRemotePlayer();
                this.setupLocalPlayer();
                this.setupPlayerHandler();
            } else {
                console.error('Remote player is not connected');
            }
        },
        setupRemotePlayer() {
            // Triggers when the media info or the player state changes
            this.remotePlayerController.addEventListener(
                cast.framework.RemotePlayerEventType.MEDIA_INFO_CHANGED,
                function (event) {
                    let session = cast.framework.CastContext.getInstance().getCurrentSession();
                    if (!session) {
                        this.mediaInfo = null;
                        return;
                    }

                    let media = session.getMediaSession();
                    if (!media) {
                        this.mediaInfo = null;
                        return;
                    }

                    if (media.playerState == PLAYER_STATE.PLAYING && this.playerState !== PLAYER_STATE.PLAYING) {
                        this.playerHandler.prepareToPlay();
                    }
                }.bind(this)
            );


            this.remotePlayerController.addEventListener(
                cast.framework.RemotePlayerEventType.IS_PAUSED_CHANGED,
                function () {
                    if (this.remotePlayer.isPaused) {
                        this.playerHandler.pause();
                    } else if (this.playerState !== PLAYER_STATE.PLAYING) {
                        // If currently not playing, start to play.
                        // This occurs if starting to play from local, but this check is
                        // required if the state is changed remotely.
                        this.playerHandler.play();
                    }
                }.bind(this)
            );

            this.remotePlayerController.addEventListener(
                cast.framework.RemotePlayerEventType.IS_MUTED_CHANGED,
                function () {
                    if (this.remotePlayer.isMuted) {
                        this.playerHandler.mute();
                    } else {
                        this.playerHandler.unMute();
                    }
                }.bind(this)
            );

            // This object will implement PlayerHandler callbacks with
            // remotePlayerController, and makes necessary updates specific
            // to remote playback.
            var playerTarget = {};

            playerTarget.play = function () {
                if (this.remotePlayer.isPaused) {
                    this.remotePlayerController.playOrPause();
                }
            }.bind(this);

            playerTarget.pause = function () {
                if (!this.remotePlayer.isPaused) {
                    this.remotePlayerController.playOrPause();
                }
            }.bind(this);

            playerTarget.stop = function () {
                this.remotePlayerController.stop();
            }.bind(this);

            playerTarget.isMediaLoaded = function (mediaIndex) {
                let session = cast.framework.CastContext.getInstance().getCurrentSession();
                if (!session) return false;

                let media = session.getMediaSession();
                if (!media) return false;

                if (media.playerState == PLAYER_STATE.IDLE) {
                    return false;
                }

                // No need to verify local mediaIndex content.
                return true;
            }.bind(this);

            /**
             * @return {number?} Current media time for the content. Always returns
             *      media time even if in clock time (conversion done when displaying).
             */
            playerTarget.getCurrentMediaTime = function () {
                if (this.isLiveContent && this.mediaInfo.metadata &&
                    this.mediaInfo.metadata.sectionStartTimeInMedia) {
                    return this.remotePlayer.currentTime - this.mediaInfo.metadata.sectionStartTimeInMedia;
                } else {
                    // VOD and live scenerios where live metadata is not provided.
                    return this.remotePlayer.currentTime;
                }
            }.bind(this);


            playerTarget.mute = function () {
                if (!this.remotePlayer.isMuted) {
                    this.remotePlayerController.muteOrUnmute();
                }
            }.bind(this);

            playerTarget.unMute = function () {
                if (this.remotePlayer.isMuted) {
                    this.remotePlayerController.muteOrUnmute();
                }
            }.bind(this);


            playerTarget.seekTo = function (time) {
                this.remotePlayer.currentTime = time;
                this.remotePlayerController.seek();
            }.bind(this);

            playerTarget.load = async function (mediaIndex) {
                let mediaSource = await this.getExternalSrcUrl();

                let mediaInfo = new chrome.cast.media.MediaInfo(mediaSource, 'video/mp4');
                mediaInfo.streamType = chrome.cast.media.StreamType.BUFFERED;
                mediaInfo.metadata = new chrome.cast.media.TvShowMediaMetadata();
                mediaInfo.metadata.title = this.screener.films[mediaIndex].title;
                mediaInfo.metadata.subtitle = this.screener.films[mediaIndex].description;
                // mediaInfo.metadata.images = [{
                //     'url': MEDIA_SOURCE_ROOT + this.mediaContents[mediaIndex]['thumb']
                // }];

                let request = new chrome.cast.media.LoadRequest(mediaInfo);
                request.currentTime = this.currentTime;

                // Do not immediately start playing if the player was previously PAUSED.
                // if (!this.playerStateBeforeSwitch || this.playerStateBeforeSwitch == PLAYER_STATE.PAUSED) {
                //     request.autoplay = false;
                // } else {
                //     request.autoplay = true;
                // }
                cast.framework.CastContext.getInstance().getCurrentSession().loadMedia(request).then(
                    function () {
                        // console.log('Remote media loaded');
                    }.bind(this),
                    function (errorCode) {
                        this.playerState = PLAYER_STATE.IDLE;

                    }.bind(this));

            }.bind(this)

            this.target = playerTarget;

            // If resuming a session, take the remote properties and continue the existing
            // playback. Otherwise, load local content.
            let session_state = cast.framework.CastContext.getInstance().getCurrentSession().getSessionState();
            if (session_state == cast.framework.SessionState.SESSION_RESUMED) {
                this.playerHandler.prepareToPlay();
            } else {
                this.playerHandler.load();
            }
        },

        setupLocalPlayer() {
            var local_player = document.getElementById("video");

            local_player.addEventListener('loadeddata', function() {
                this.playerHandler.load();
            }.bind(this));
            local_player.addEventListener("play", function () {
                this.playerHandler.play();
            }.bind(this));

            local_player.addEventListener("pause", function () {
                this.playerHandler.pause();
            }.bind(this));

            local_player.addEventListener("seeked", function () {
                this.playerHandler.seekTo(local_player.currentTime);
            }.bind(this));
        },
        setupPlayerHandler() {
            let handler = {};

            // handler.play = function () {
            //     if (this.remotePlayer.isPaused) {
            //         this.remotePlayerController.playOrPause();
            //     }
            // }.bind(this);

            handler.play = function () {
                if (this.playerState == PLAYER_STATE.IDLE ||
                    !this.target.isMediaLoaded(this.currentFilmIndex)
                ) {
                    this.target.load(this.currentFilmIndex);
                    return;
                }

                this.playerState = PLAYER_STATE.PLAYING;
                this.target.play();
            }.bind(this);

            handler.pause = function () {
                this.target.pause();
                this.playerState = PLAYER_STATE.PAUSED;
            }.bind(this);

            handler.stop = function () {
                this.playerState = PLAYER_STATE.IDLE;
                this.target.stop();
            }.bind(this);

            handler.load = function (mediaIndex = null) {
                if (!mediaIndex) {
                    mediaIndex = this.currentFilmIndex;
                }
                this.playerState = PLAYER_STATE.BUFFERING;
                this.target.load(mediaIndex);
            }.bind(this);

            handler.prepareToPlay = function () {
                this.playerState = PLAYER_STATE.LOADED;
                handler.play();
            }.bind(this);

            handler.mute = function () {
                this.target.mute();
            }.bind(this);

            handler.unMute = function () {
                this.target.unMute();
            }.bind(this);

            handler.seekTo = function (time) {
                this.target.seekTo(time);
            }.bind(this);

            return handler;
        },

        async getExternalSrcUrl() {
            let media_src = await this.$store.dispatch('screening/getExternalSrcUrl',{
                screener_id: this.screener.id,
                film_id: this.screener.films[this.currentFilmIndex].id
            })
            .then((response) => {
                return response.url
            })
            .catch((error) => {
                console.error(error);
            })
            return media_src
        }
    }
}
const PLAYER_STATE = {
    // No media is loaded into the player. For remote playback, maps to
    // the PlayerState.IDLE state.
    IDLE: 'IDLE',
    // Player is in PLAY mode but not actively playing content. For remote
    // playback, maps to the PlayerState.BUFFERING state.
    BUFFERING: 'BUFFERING',
    // The media is loaded but not playing.
    LOADED: 'LOADED',
    // The media is playing. For remote playback, maps to the PlayerState.PLAYING state.
    PLAYING: 'PLAYING',
    // The media is paused. For remote playback, maps to the PlayerState.PAUSED state.
    PAUSED: 'PAUSED'
};


export { chromeCast }
